module.exports = __webpack_public_path__ + "img/audio-icon-selected.260b9ce9.svg";